import * as s from '../Eliminator/Admin/EliminatorAdminManualPickEntry.scss'
import SeasonSelector from '../Football/SeasonSelector'
import SeasonModeSelector from '../Football/SeasonModeSelector'
import WeekSelector from '../Football/WeekSelector'
import PlayerListItem from '../Player/PlayerListItem'
import NflTeamListItem from '../Football/NflTeamListItem'
import PickButton from '../Eliminator/Admin/EliminatorAdminManualEntryPickButton'
import Modal from '@severed-links/common.modal'
import terminatorErrorMessage from './terminatorErrorMessage'
import React, { useEffect, useState } from 'react'
import { Alert, Button, Form, ListGroup } from 'react-bootstrap'
import useTerminatorAdminSeason from './useTerminatorAdminSeason'
import { getManualEntry, saveManualPick } from '@severed-links/common.redherrings-reducers/terminatorAdmin'

const TerminatorManualEntry = () => {
  const { dispatch, seasons, seasonId, setSelected, initialPhase, initialWeek, setPickWindow } = useTerminatorAdminSeason()
  const phase = initialPhase
  const week = String(initialWeek)
  const [playerId, setPlayerId] = useState('')
  const [teamId, setTeamId] = useState('')
  const [data, setData] = useState(null)
  const [message, setMessage] = useState('')
  const [busy, setBusy] = useState(false)
  const [refresh, setRefresh] = useState(0)
  useEffect(() => {
    setData(null); setPlayerId(''); setMessage('')
    if (!seasonId) return
    let active = true
    const load = async () => {
      try {
        const action = await dispatch(getManualEntry(seasonId, phase, Number(week)))
        if (action.error || action.payload?.messageType === 'error') throw new Error(action.payload?.response?.message || action.payload?.message || 'Unable to load entries.')
        if (active) setData(action.payload)
      } catch (error) { if (active) setMessage(terminatorErrorMessage(error)) }
    }
    load()
    return () => { active = false }
  }, [dispatch, seasonId, phase, week, refresh])
  const choosePlayer = player => { setPlayerId(player.playerId); setTeamId(player.teamId || ''); setMessage('') }
  const save = async () => {
    if (busy) return
    setBusy(true)
    try {
      const action = await dispatch(saveManualPick({ seasonId, seasonMode: phase, week: Number(week), playerId, teamId: teamId || null }))
      if (action.error || action.payload?.messageType === 'error') throw new Error(action.payload?.response?.message || action.payload?.message || 'Unable to save pick.')
      setData(action.payload); setMessage(action.payload.message); setPlayerId('')
    } catch (error) { setMessage(terminatorErrorMessage(error)) }
    setBusy(false)
  }
  const season = seasons.find(item => item.seasonId === seasonId) || {}
  const player = data?.players.find(item => item.playerId === playerId)
  const teamPick = id => ({ ...(data?.teams.find(item => item._id === id) || {}), teamId: id })
  const picks = (data?.players || []).filter(item => item.teamId).length
  return <div className={s.container}>
    <section className={s.pageHeader}><div className={s.headerCopy}><div className={s.eyebrow}>Terminator Admin</div><h2 className={s.title}>Manual Pick Entry</h2><div className={s.subtitle}>{season.seasonName} {phase} Week {week}</div></div>
      <div className={s.headerActions} style={busy ? { pointerEvents: 'none', opacity: 0.5 } : {}}>
        <SeasonSelector seasons={seasons} season={season} onSelect={name => setSelected(seasons.find(item => item.seasonName === name)?.seasonId)} />
        <SeasonModeSelector showPreseason={false} seasonMode={phase} onSelect={value => setPickWindow(value, 1)} />
        <WeekSelector seasons={seasons} season={season} week={`${phase === 'Postseason' ? 'PW' : 'W'}${week}`} showPlayoffWeeks onSelect={value => setPickWindow(value.startsWith('PW') ? 'Postseason' : 'Regular', Number(value.replace(/\D/g, '')))} />
        <Button variant='light' disabled={busy} onClick={() => setRefresh(value => value + 1)}>Refresh</Button>
      </div>
    </section>
    {message && !playerId ? <Alert variant='info'>{message}</Alert> : null}
    <section className={s.summaryGrid}>
      <div className={s.summaryPill}><span>{data?.players.length || 0}</span>players</div>
      <div className={s.summaryPill}><span>{picks}</span>picks entered</div>
      <div className={`${s.summaryPill} ${s.warning}`}><span>{(data?.players.length || 0) - picks}</span>no pick</div>
    </section>
    <section className={s.entryCard}><div className={s.listHeader}><div>Player</div><div>Pick</div></div>
      <ListGroup className={s.list}>{data?.players.map(item => <PlayerListItem key={item.playerId} player={item} className={s.playerRow}
        rightDetail={<PickButton p={teamPick(item.teamId)} disabled={busy} variant={item.teamId ? 'success' : 'light'} onPlayerSelect={() => choosePlayer(item)} />} />)}
        {data && !data.players.length ? <ListGroup.Item className={s.emptyState}>No players registered.</ListGroup.Item> : null}
      </ListGroup>
    </section>
    {player ? <Modal heading={`Edit ${season.seasonName} ${phase} Week ${week} Pick for ${player.firstName} ${player.lastName}`}
      size='lg' className={s.pickModal} dialogClassName={s.pickDialog} bodyClass={s.pickBody} show showFooter={false} onClose={() => { if (!busy) setPlayerId('') }}>
      <div className={s.modalContainer}>
        <p>Choose a losing team. Previously used teams are unavailable.</p>
        {message ? <Alert variant='danger'>{message}</Alert> : null}
        <ListGroup className={s.manualPickModalListGroup}>
          <ListGroup.Item action disabled={busy} active={!teamId} className={s.blankPickItem} onClick={() => setTeamId('')}>Clear pick</ListGroup.Item>
          {data.teams.map(team => <NflTeamListItem key={team._id} teamId={team._id} teamName={team.nflTeam} cityAsTitle mascot={team.mascot} city={team.city} className={s.teamPickItem}
            variant={teamId === team._id ? 'success' : 'light'} disabled={busy || (player.usedTeamIds || []).includes(team._id)} onClick={() => setTeamId(team._id)} />)}
        </ListGroup>
        <p>Selected: {data.teams.find(team => team._id === teamId)?.nflTeam || 'Clear pick'}</p>
        <Form onSubmit={event => { event.preventDefault(); save() }}>
          <Button type='submit' disabled={busy}>{busy ? 'Saving pick…' : 'Save manual pick'}</Button>
        </Form>
      </div>
    </Modal> : null}
  </div>
}
export default TerminatorManualEntry
